export const ALL_ENTITIES_ID = 'all';

/**
 * Prepare filter ids for request
 */
export function getFilterEntityIds(entityId?: string) {
  if (!entityId) {
    return undefined;
  }

  return [entityId];
}
